import { call, put, all, fork, takeEvery } from "redux-saga/effects";

import { blogListRedux } from "./reducers";
import {
  BlogList,
  BlogListByCategory,
  BlogListForHeader,
  BlogListForUpdates,
  SearchBlogList,
} from "@/app/service/Blogs";

function* getBlogListSaga(action) {
  try {
    const response = yield call(BlogList, action.payload);
    yield put(blogListRedux.actions.getBlogListSuccess(response.data));
  } catch (error) {
    yield put(blogListRedux.actions.getBlogListFailure(error));
  }
}

///Blogs list by category
function* getBlogListByCategorySaga(action) {
  try {
    const response = yield call(BlogListByCategory, action.payload);

    yield put(
      blogListRedux.actions.getBlogListByCategorySuccess(response.data)
    );
  } catch (error) {
    yield put(blogListRedux.actions.getBlogListByCategoryFailure(error));
  }
}

// Blog lists for header secction
function* getBlogListForHeaderSaga(action) {
  try {
    const response = yield call(BlogListForHeader, action.payload);

    yield put(blogListRedux.actions.getBlogListForHeaderSuccess(response.data));
  } catch (error) {
    yield put(blogListRedux.actions.getBlogListForHeaderFailure(error));
  }
}

// Blog lists for Updates section
function* getBlogListForUpdatesSaga(action) {
  try {
    const response = yield call(BlogListForUpdates, action.payload);

    yield put(
      blogListRedux.actions.getBlogListForUpdatesSuccess(response.data)
    );
  } catch (error) {
    yield put(blogListRedux.actions.getBlogListForUpdatesFailure(error));
  }
}

// Blog Search lists
function* getBlogSearchListSaga(action) {
  try {
    const response = yield call(SearchBlogList, action.payload);

    yield put(blogListRedux.actions.getBlogSearchListSuccess(response.data));
  } catch (error) {
    yield put(blogListRedux.actions.getBlogSearchListFailure(error));
  }
}

/// Watch list
export function* watchBlogList() {
  yield takeEvery(
    blogListRedux.actions.getBlogListRequest.type,
    getBlogListSaga
  );
}

export function* watchBlogListByCategory() {
  yield takeEvery(
    blogListRedux.actions.getBlogListByCategoryRequest.type,
    getBlogListByCategorySaga
  );
}

export function* watchBlogListForHeader() {
  yield takeEvery(
    blogListRedux.actions.getBlogListForHeaderRequest.type,
    getBlogListForHeaderSaga
  );
}

export function* watchBlogListForUpdates() {
  yield takeEvery(
    blogListRedux.actions.getBlogListForUpdatesRequest.type,
    getBlogListForUpdatesSaga
  );
}

export function* watchBlogSearchList() {
  yield takeEvery(
    blogListRedux.actions.getBlogSearchListRequest.type,
    getBlogSearchListSaga
  );
}

export default function* BlogListSagas() {
  yield all([fork(watchBlogList)]);
  yield all([fork(watchBlogListByCategory)]);
  yield all([fork(watchBlogListForHeader)]);
  yield all([fork(watchBlogListForUpdates)]);
  yield all([fork(watchBlogSearchList)]);
}
